// ~/plugins/scroll-offset.client.ts
import { defineNuxtPlugin, useRouter, useRoute } from '#app';
import { getLenis } from '~/utils/lenis';

export default defineNuxtPlugin(() => {
  const SCROLL_OFFSET = 80;
  const router = useRouter();
  const route = useRoute();

  const scrollToHash = async (hash: string) => {
    const el = document.getElementById(hash);
    if (!el) return;

    await new Promise(requestAnimationFrame);
    await new Promise(requestAnimationFrame);

    // Scroll through Lenis when active so it doesn't override a native scrollTo.
    const lenis = getLenis();
    if (lenis) {
      lenis.scrollTo(el, { offset: -SCROLL_OFFSET });
      return;
    }

    const top = el.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    if (!target) {
      return;
    }

    const link = target.closest('a[href^="#"], a[href^="/#"]') as HTMLAnchorElement | null;
    if (!link) {
      return;
    }

    const href = link.getAttribute('href');
    if (!href) {
      return;
    }

    const [path, hash] = href.split('#');
    if (!hash) {
      return;
    }

    event.preventDefault();
    if (!path || path === '/' || path === route.path) {
      scrollToHash(hash);
    } else {
      router.push(path).then(() => {
        nextTick(() => scrollToHash(hash));
      });
    }
  });

  if (window.location.hash) {
    nextTick(() => scrollToHash(window.location.hash.substring(1)));
  }
});
